import React from "react";

import { ISearchResult } from "types";

import { normalizeSearchResult } from "utils";
import { DefaultTeaser } from "components";
import classNames from "classnames";

interface ToolSearchResultsProps {
  results: ISearchResult[];
  currentPage?: number;
  isLoading?: boolean;
}

export const ToolSearchResults: React.FC<ToolSearchResultsProps> = ({
  results,
  currentPage = 1,
  isLoading,
}) => (
  <div
    className={classNames("tool-search-results", { "is-loading": isLoading })}
  >
    <ul className="grid of-2 tool-search-results__list">
      {results.map((result, index) => (
        <li key={`search-result-${currentPage}-${index}`}>
          <DefaultTeaser {...normalizeSearchResult(result)} />
        </li>
      ))}
    </ul>
  </div>
);
